export const logs = [
  {
    title: "VandaPardakht (user panel)",
    version: "1.18.0",
    date: "Oct 20, 2026",
    changes: [
      "ریفکتور فیچر کسب‌وکار شامل جدول کسب‌وکارها، فرم ساخت کسب‌وکار، صفحه جزئیات کسب‌وکار و داشبورد کسب‌وکار",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.17.1",
    date: "Oct 14, 2026",
    changes: [
      "اصلاح فرم ایمیل و گفت‌وگوی تغییر نشان کسب‌وکار در سایدبار",
      "به‌روزرسانی نشان کسب‌وکار در سایدبار پس از تغییر آن",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.17.0",
    date: "Oct 12, 2026",
    changes: [
      "تکمیل فیچر حساب‌های بانکی شامل فهرست، فرم، استعلام شبا و کارت و فعال‌سازی حساب",
      "افزودن آزمون‌های خودکار برای سناریوهای حساب‌های بانکی",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.16.4",
    date: "Oct 4, 2026",
    changes: ["افزودن آزمون‌های خودکار برای ورود و تأیید احراز هویت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.16.3",
    date: "Sep 29, 2026",
    changes: [
      "افزودن آزمون‌های خودکار و بهبود مدیریت خطا در فرایند تأیید",
      "رفع پیام خطای نادرست عدم اتصال به اینترنت هنگام وارد کردن شماره کارت نامعتبر برای افزودن حساب",
      "اصلاح نمایش شماره شبا در فرم افزودن حساب در موبایل",
      "اصلاح غلط املایی متن راهنمای افزودن کسب‌وکار؛ «بارگذاری»",
      "اصلاح نمایش آواتار کسب‌وکار در صفحه کسب‌وکار در موبایل",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.16.2",
    date: "Sep 20, 2026",
    changes: ["افزودن آزمون‌های واحد برای فرم‌ها و اعتبارسنجی احراز هویت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.16.1",
    date: "Sep 16, 2026",
    changes: ["به‌روزرسانی صفحه پروفایل کاربر", "استفاده از نشانی تنظیم‌شده برای فیلدهای فرم کارت پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.16.0",
    date: "Sep 14, 2026",
    changes: [
      "ریفکتور فیچر پروفایل کاربر شامل ویرایش اطلاعات، تصویر پروفایل، وضعیت کاربر و اعتبارسنجی اطلاعات",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.15.0",
    date: "Aug 18, 2026",
    changes: ["بررسی و اصلاح وضعیت فعال بودن کپچا در صفحه ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.14.1",
    date: "Aug 3, 2026",
    changes: ["اصلاح محاسبه مبلغ و گرد کردن آن در فرم پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.14.0",
    date: "Aug 1, 2026",
    changes: ["ریفکتور فیچر احراز هویت شامل صفحات ورود و تأیید، کپچا، زمان‌سنج و سرویس‌های API"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.13.0",
    date: "Jul 27, 2026",
    changes: ["مهاجرت پیکربندی TypeScript و ESLint به ساختار جدید"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.12.3",
    date: "Jul 13, 2026",
    changes: ["جلوگیری از ارسال ناخواسته فرم هنگام کلیک روی دکمه‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.12.2",
    date: "Jul 11, 2026",
    changes: ["افزودن پیام اطلاع‌رسانی درباره رفتار پیش‌فرض خروجی اکسل تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.12.1",
    date: "Jun 30, 2026",
    changes: [
      "واکنش‌گرا شدن بخش بازاریابی و بهبود نمایش آن در اندازه‌های مختلف صفحه",
      "به‌روزرسانی ساختار صفحه بازاریابی، مسیرها و ارتباطات API مرتبط",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.12.0",
    date: "Jun 29, 2026",
    changes: ["افزودن صفحه تسویه‌های بازاریابی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.17",
    date: "Jun 16, 2026",
    changes: ["اصلاح شمارش معکوس OTP و حفظ وضعیت فرم هنگام جابه‌جایی تب", "بهبود پیام تأیید تراکنش"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.15",
    date: "Jun 6, 2026",
    changes: ["بهبود پیام تسویه و بستن هشدار پین درگاه پس از به‌روزرسانی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.14",
    date: "May 10, 2026",
    changes: ["اصلاح پاک شدن فیلدهای OTP هنگام استفاده از دکمه بازگشت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.13",
    date: "May 9, 2026",
    changes: ["حذف بسته منسوخ‌شده نمایش متن و بازنویسی دکمه نمایش بیشتر و کمتر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.12",
    date: "May 2, 2026",
    changes: ["تغییر نشانی پروکسی Nexus به DevOpsyar", "حذف بسته منسوخ‌شده نمایش متن"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.11",
    date: "Apr 13, 2026",
    changes: ["افزودن کپچا به ارسال دوباره OTP"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.10",
    date: "Apr 8, 2026",
    changes: ["بهبود نمایش تصویر و دریافت رسید در فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.9",
    date: "Apr 4, 2026",
    changes: ["اصلاح نشانی تصویر در فرم پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.8",
    date: "Feb 27, 2026",
    changes: ["اصلاح نمایش فایل‌ها و تصاویر دریافتی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.5",
    date: "Feb 15, 2026",
    changes: ["بهبود پیش‌نمایش فایل‌های بارگذاری‌شده", "اصلاح صفحه جزئیات کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.4",
    date: "Feb 3, 2026",
    changes: ["اصلاح پیش‌نمایش فایل‌های بارگذاری‌شده"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.3",
    date: "Feb 2, 2026",
    changes: ["اصلاح بارگذاری فایل‌های اکسل در درخواست‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.11.2",
    date: "Feb 1, 2026",
    changes: ["بهبود صفحه درخواست‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.10.5",
    date: "Jan 10, 2026",
    changes: ["اصلاح پیش‌نمایش فایل بارگذاری‌شده"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.10.4",
    date: "Jan 4, 2026",
    changes: ["اصلاح جایگاه تاریخ در جست‌وجوی پیشرفته تراکنش‌های پوز"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.10.3",
    date: "Dec 22, 2025",
    changes: ["اصلاح فیلتر و انتخاب خروجی اکسل در فهرست تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.10.2",
    date: "Dec 14, 2025",
    changes: ["بهبود پیام حالت خالی فهرست فرم‌های پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.10.1",
    date: "Dec 8, 2025",
    changes: ["نمایش وضعیت فایل‌ها و کد رهگیری وندا در رسیدها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.9",
    date: "Nov 30, 2025",
    changes: ["اصلاح فهرست‌های انتخابی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.8",
    date: "Nov 10, 2025",
    changes: ["بهبود جست‌وجوی تراکنش‌های پوز و فهرست‌های انتخابی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.7",
    date: "Oct 28, 2025",
    changes: ["بهبود ظاهر صفحه ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.6",
    date: "Oct 27, 2025",
    changes: ["افزودن کپچا به درخواست ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.5",
    date: "Oct 25, 2025",
    changes: ["افزودن کپچا به صفحه ورود و مدیریت حالت‌های بارگذاری"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.3",
    date: "Sep 14, 2025",
    changes: ["اصلاح نمایش تصاویر فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.1",
    date: "Aug 27, 2025",
    changes: ["بهبود تأیید تراکنش با تنظیم زمان انتظار و مسیر جدید API"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.9.0",
    date: "Aug 26, 2025",
    changes: ["افزودن و اصلاح API پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.160",
    date: "Aug 25, 2025",
    changes: ["اصلاح صفحه تأیید تراکنش و حذف موارد اضافی از فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.159",
    date: "Aug 18, 2025",
    changes: ["به‌روزرسانی فرایند خرید به نسخه ۲"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.158",
    date: "Aug 3, 2025",
    changes: ["بهبود نمایش واکنش‌گرای سامانه در موبایل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.157",
    date: "Jul 30, 2025",
    changes: ["رفع مشکل مبالغ ۱۸ رقمی", "بهبود بارگذاری صفحه تأیید تراکنش"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.156",
    date: "Jul 29, 2025",
    changes: ["اصلاح فهرست تراکنش‌های پوز"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.155",
    date: "Jul 28, 2025",
    changes: ["اصلاح نمایش کد رهگیری برای تراکنش‌های ۱۸ رقمی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.153",
    date: "Jul 26, 2025",
    changes: ["اصلاح وضعیت تأیید تراکنش و نمایش کد رهگیری"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.151",
    date: "Jul 7, 2025",
    changes: ["افزودن فیلتر «تأییدشده توسط کاربر» به جست‌وجوی تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.150",
    date: "Jun 29, 2025",
    changes: ["اصلاح پیوندهای خروجی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.149",
    date: "Jun 8, 2025",
    changes: ["اصلاح ارسال فرم احراز هویت در حالت ورودی نامعتبر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.148",
    date: "Jun 7, 2025",
    changes: ["بهبود به‌روزرسانی اطلاعات حساب بانکی و دریافت رسید"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.146",
    date: "Jun 2, 2025",
    changes: ["بهبود ظاهر پیام‌های اطلاع‌رسانی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.141",
    date: "May 6, 2025",
    changes: ["اصلاح عملکرد دکمه ثبت فرم کسب‌وکار و احراز هویت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.140",
    date: "May 4, 2025",
    changes: ["افزودن نام انگلیسی بانک در فرم افزودن حساب"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.139",
    date: "Apr 29, 2025",
    changes: ["اصلاح بارگذاری تصاویر با استفاده از محل ذخیره‌سازی جدید"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.133",
    date: "Apr 9, 2025",
    changes: ["اصلاح ظاهر حساب‌های بانکی و درگاه‌ها", "بهبود فرم‌های پرداخت و کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.130",
    date: "Apr 6, 2025",
    changes: ["اصلاح اعتبارسنجی درگاه و فهرست کسب‌وکارها", "رفع مشکل بسته شدن فهرست تاریخ هنگام کلیک بیرون"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.128",
    date: "Mar 17, 2025",
    changes: ["بهبود ارتفاع و نمایش واکنش‌گرای صفحات"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.126",
    date: "Mar 10, 2025",
    changes: ["افزودن شناسه درگاه به خروجی اکسل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.125",
    date: "Mar 9, 2025",
    changes: ["بهبود ظاهر تراکنش‌های پوز و صفحه گفت‌وگو", "اصلاح صفحه جزئیات کسب‌وکار و فرم ثبت‌نام"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.124",
    date: "Mar 8, 2025",
    changes: ["بهبود صفحه ورود، پیام انقضای کارت‌ها و بارگذاری تصاویر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.123",
    date: "Mar 5, 2025",
    changes: ["رفع خطای تاریخ و زمان در خروجی اکسل تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.122",
    date: "Feb 26, 2025",
    changes: ["بهبود صفحه ورود کاربر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.121",
    date: "Feb 23, 2025",
    changes: ["رفع خطای اعتبارسنجی اطلاعات کاربر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.120",
    date: "Feb 22, 2025",
    changes: [
      "بهبود صفحه حساب‌های بانکی و ورودی شبا",
      "افزودن حالت بارگذاری داشبورد و تیک پذیرش قوانین در صفحه ورود",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.119",
    date: "Jan 15, 2025",
    changes: ["بهبود ظاهر صفحه ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.118",
    date: "Jan 13, 2025",
    changes: ["قابل تنظیم شدن سقف مبلغ فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.117",
    date: "Jan 12, 2025",
    changes: ["افزودن تکمیل خودکار OTP و اصلاح محدودیت طول ورودی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.116",
    date: "Jan 11, 2025",
    changes: ["بهبود ظاهر صفحه گفت‌وگو و نمایش اعداد فارسی در صفحه ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.115",
    date: "Jan 1, 2025",
    changes: ["بهبود فهرست انتخاب دسته‌بندی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.114",
    date: "Dec 31, 2024",
    changes: ["اصلاح ظاهر صفحه گفت‌وگو"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.113",
    date: "Dec 30, 2024",
    changes: ["تنظیم مرتب‌سازی پیش‌فرض تراکنش‌های پوز بر اساس زمان فاکتور"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.112",
    date: "Dec 24, 2024",
    changes: ["بهبود ظاهر ورودی شبا و صفحه‌بندی فهرست‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.111",
    date: "Dec 23, 2024",
    changes: ["رفع خطای فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.110",
    date: "Dec 22, 2024",
    changes: ["رفع خطاهای فرم‌های کسب‌وکار و پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.109",
    date: "Dec 21, 2024",
    changes: ["اصلاح ورود اولیه و نمایش واکنش‌گرای صفحه گفت‌وگو", "بهبود ظاهر تراکنش‌های پوز و فرم QR"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.108",
    date: "Dec 18, 2024",
    changes: ["بهبود صفحه اطلاعات کاربر و جلوگیری از انتخاب تاریخ آینده برای ثبت قانونی کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.107",
    date: "Dec 17, 2024",
    changes: ["اصلاح ظاهر فرم پرداخت و صفحه گفت‌وگو"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.106",
    date: "Dec 16, 2024",
    changes: ["افزودن پیام‌های اطلاع‌رسانی و اعلان‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.105",
    date: "Dec 11, 2024",
    changes: ["افزودن وضعیت و فیلتر نوع تراکنش به فهرست تراکنش‌های پوز"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.104",
    date: "Dec 10, 2024",
    changes: ["بهبود توضیحات صفحه جزئیات تراکنش و رسید پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.103",
    date: "Dec 9, 2024",
    changes: ["افزودن دکمه بازگشت به رسید تراکنش و بهبود نمایش کسب‌وکار پوز", "اصلاح صفحه جزئیات فرم"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.102",
    date: "Dec 8, 2024",
    changes: ["افزودن فهرست خروجی‌ها با صفحه‌بندی و نمایش مناسب در موبایل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.101",
    date: "Dec 7, 2024",
    changes: ["بهبود فهرست خروجی‌ها و فرم پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.100",
    date: "Dec 4, 2024",
    changes: ["رفع خطاهای پنل کاربر در فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.99",
    date: "Nov 30, 2024",
    changes: ["تکمیل صفحه درخواست‌ها و اصلاح نمایش زمان تسویه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.98",
    date: "Nov 27, 2024",
    changes: ["اصلاح بارگذاری فایل در درخواست‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.97",
    date: "Nov 24, 2024",
    changes: ["اصلاح نام فارسی فیلدها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.95",
    date: "Nov 19, 2024",
    changes: [
      "بهبود فهرست تراکنش‌های پوز و نمایش موبایلی",
      "افزودن خروج خودکار هنگام پایان اعتبار ورود و کلید فعال‌سازی حساب بانکی",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.94",
    date: "Nov 18, 2024",
    changes: [
      "افزودن امکان بارگذاری PDF در درخواست‌ها و اصلاح فهرست کسب‌وکار و گفت‌وگو",
      "رفع خطاهای اطلاعات کاربر و هشدار خروج",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.93",
    date: "Nov 17, 2024",
    changes: [
      "بهبود ورود با تکمیل خودکار OTP و نمایش واکنش‌گرای تراکنش‌ها",
      "اصلاح مرتب‌سازی تراکنش‌ها و نمایش تسویه و پوز در کارت کسب‌وکار",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.92",
    date: "Nov 16, 2024",
    changes: [
      "بهبود نمایش موبایلی فرم تسویه، پروفایل و داشبورد کسب‌وکار",
      "رفع خطای مبلغ پرداخت پیوند و امکان چسباندن OTP",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.91",
    date: "Nov 13, 2024",
    changes: [
      "واکنش‌گرا شدن صفحات ورود، ثبت کسب‌وکار، درخواست‌ها و درگاه‌ها",
      "جلوگیری از فوکوس خودکار ناخواسته در ورودی‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.90",
    date: "Nov 12, 2024",
    changes: [
      "بهبود نمایش موبایلی فهرست تراکنش‌ها و کارت‌های کسب‌وکار",
      "اصلاح جست‌وجو و محدودیت تراکنش‌های پوز و فرم پرداخت",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.89",
    date: "Nov 11, 2024",
    changes: ["اصلاح کپی پین درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.88",
    date: "Nov 6, 2024",
    changes: ["بهبود کنترل ورودی‌های سفارشی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.87",
    date: "Nov 5, 2024",
    changes: ["اصلاح مسیرها و ظاهر فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.86",
    date: "Oct 30, 2024",
    changes: ["به‌روزرسانی فونت‌ها و تصاویر سامانه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.85",
    date: "Oct 29, 2024",
    changes: ["بهبود کارت پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.84",
    date: "Oct 27, 2024",
    changes: ["اصلاح ظاهر صفحه پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.83",
    date: "Oct 26, 2024",
    changes: [
      "رفع خطای به‌روزرسانی اطلاعات کاربر پس از تغییر تصویر پروفایل",
      "اصلاح نمایش تصاویر خالی و مقادیر پیش‌فرض فرم احراز هویت",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.82",
    date: "Oct 23, 2024",
    changes: ["بهبود ظاهر صفحه پرداخت پیوند و بازسازی صفحه پروفایل", "امکان به‌روزرسانی تصویر پروفایل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.81",
    date: "Oct 22, 2024",
    changes: ["رفع خطاهای احراز هویت و فرم درگاه و تکمیل قالب‌های ایمیل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.80",
    date: "Oct 21, 2024",
    changes: [
      "اصلاح به‌روزرسانی کارت‌های درگاه و فهرست حساب‌های بانکی",
      "افزودن صفحه کسب‌وکار و بهبود فهرست‌های انتخابی",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.79",
    date: "Oct 20, 2024",
    changes: ["به‌روزرسانی نشان و تصاویر سامانه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.78",
    date: "Oct 19, 2024",
    changes: ["بهبود کارت فرم پرداخت و کارت درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.77",
    date: "Oct 16, 2024",
    changes: ["افزودن صفحه‌بندی تراکنش‌های پوز"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.76",
    date: "Oct 14, 2024",
    changes: ["تکمیل ورود مدیر و دسترسی‌های احراز هویت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.74",
    date: "Oct 12, 2024",
    changes: ["بهبود جزئیات گفت‌وگو و صفحه‌بندی تسویه", "اصلاح نشانی صفحه پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.73",
    date: "Oct 8, 2024",
    changes: [
      "افزودن نشان‌های شتاب و شاپرک و اصلاح ظاهر فرم پرداخت",
      "بهبود صفحه تراکنش‌های پوز و پرداخت پیوند",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.72",
    date: "Oct 7, 2024",
    changes: [
      "افزودن نمایش پوز در داشبورد و سایدبار کسب‌وکار",
      "اصلاح فهرست تراکنش‌های پوز و ظاهر پرداخت پیوند",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.71",
    date: "Oct 6, 2024",
    changes: [
      "افزودن دکمه چاپ به فرم و کارت‌های موجودی داشبورد کسب‌وکار",
      "بهبود پیام خطای درگاه و وضعیت دسته‌بندی فرم کسب‌وکار",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.70",
    date: "Oct 5, 2024",
    changes: ["بهبود نمایش واکنش‌گرای فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.69",
    date: "Oct 2, 2024",
    changes: [
      "تکمیل نمایش فهرست کاربران در منوی بالای همه صفحات",
      "افزودن صفحه اصناف و منوی تنظیمات مربوط به آن",
      "افزودن صفحه کارمزدهای وندا ولت",
      "تکمیل بخش کارتخوان ادمین شامل تراکنش‌ها، پایانه‌ها و خروجی اکسل",
      "افزودن امکان فراخوانی موجودی در بخش‌های مختلف سامانه",
      "اصلاح خروجی اکسل و جست‌وجوی پیشرفته در فهرست تراکنش‌ها",
      "نمایش نام کاربر، موجودی، نوع تسویه و حساب در فهرست کسب‌وکارها",
      "نمایش موجودی در فهرست کاربران",
      "اصلاح عملکرد OTP صفحه ورود کاربر در موبایل",
      "افزودن PSP و نوع پذیرنده به جست‌وجوی پیشرفته تراکنش‌ها",
      "استفاده از زمان پرداخت برای تاریخ تراکنش‌های نوع پوز",
      "اصلاح ظاهر بخش کارمزدهای وندا ولت",
      "رفع مشکلات سرویس‌های سمت سرور مرتبط با این بخش‌ها",
      "افزودن نوار پیمایش به نوار کناری",
      "اعمال قالب‌بندی بومی برای اعداد کارمزدها در پنل ادمین",
      "اصلاح اعتبارسنجی پیوند درگاه",
      "محدود کردن ویرایش تصاویر اطلاعات کسب‌وکار به تصویر لوگو",
      "حذف اکسل و جست‌وجو از درخواست‌های درگاه",
      "افزودن اتصال به وندا ولت، منوی بالا و امکان ویرایش و حذف در فهرست درخواست‌ها",
      "عدم نمایش آیکون فعال‌سازی در کارت و فرم درگاه تا زمان تأیید درگاه",
      "افزودن قالب‌بندی بومی به دکمه موجودی در فهرست کاربران",
      "افزودن هشدار هنگام خروج از حساب کاربری",
      "بسته شدن پنجره خروجی اکسل پس از دریافت خروجی تراکنش‌ها",
      "امکان وارد کردن عدد در پیوند فرم کاربر",
      "اصلاح فهرست انتخاب ثبت درگاه و حذف بخش گمراه‌کننده",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.68",
    date: "Oct 1, 2024",
    changes: ["افزودن سایدبار موبایل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.67",
    date: "Sep 29, 2024",
    changes: ["بهبود فرم درگاه، فرم پرداخت پیش‌فرض و وضعیت تسویه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.66",
    date: "Sep 25, 2024",
    changes: ["بهبود ورود OTP با صفحه‌کلید عددی و اصلاح ورودی OTP"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.65",
    date: "Sep 24, 2024",
    changes: ["اصلاح فرم ایمیل و کارت‌های پرداخت و درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.63",
    date: "Sep 18, 2024",
    changes: ["اصلاح غیرفعال شدن دکمه در پرداخت پیوند"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.62",
    date: "Sep 17, 2024",
    changes: ["اصلاح صفحات کسب‌وکار جدید و درگاه‌های در انتظار تأیید"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.61",
    date: "Sep 16, 2024",
    changes: [
      "بازسازی صفحه حساب‌های بانکی و اصلاح فهرست حساب‌ها و کسب‌وکارها",
      "اصلاح تاریخ درخواست‌ها و فهرست گفت‌وگو",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.60",
    date: "Sep 15, 2024",
    changes: [
      "اصلاح اعتبارسنجی فرم پرداخت و ثبت درگاه",
      "افزودن هشدار خروج و بهبود بارگذاری و موجودی فهرست کسب‌وکارها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.59",
    date: "Sep 14, 2024",
    changes: ["بازسازی صفحه فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.58",
    date: "Sep 11, 2024",
    changes: ["بهبود فهرست کسب‌وکار و تراکنش و جست‌وجوی تراکنش‌های تأییدشده", "اصلاح کارت‌های فرم پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.57",
    date: "Sep 10, 2024",
    changes: [
      "نمایش کارت‌های فهرست کسب‌وکار و افزودن کپی و اشتراک‌گذاری به کارت‌های پرداخت پیوند",
      "اصلاح اعتبارسنجی فرم پرداخت پیوند",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.56",
    date: "Sep 9, 2024",
    changes: ["اصلاح فهرست کسب‌وکار و کارت‌های درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.55",
    date: "Sep 3, 2024",
    changes: ["بهبود فهرست فرم‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.54",
    date: "Sep 1, 2024",
    changes: [
      "افزودن نمودار خطی به جزئیات کسب‌وکار",
      "افزودن صفحه‌بندی به فهرست فرم‌ها و تکمیل بخش جزئیات درگاه",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.53",
    date: "Aug 28, 2024",
    changes: ["تکمیل اعتبارسنجی فرم‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.52",
    date: "Aug 27, 2024",
    changes: [
      "افزودن داشبورد کسب‌وکار، تنظیمات تسویه و نمودار درآمد",
      "بهبود جست‌وجوی تراکنش‌ها و نمایش جزئیات و صورتحساب",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.51",
    date: "Aug 26, 2024",
    changes: ["اصلاح خروجی اکسل و جست‌وجوی پیشرفته تراکنش‌ها", "بهبود افزودن تسویه و ظاهر تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.50",
    date: "Aug 24, 2024",
    changes: ["بازسازی صفحه کسب‌وکار و افزودن نشان آن به سایدبار", "تکمیل اعتبارسنجی فرم درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.49",
    date: "Aug 21, 2024",
    changes: ["افزودن داشبورد به صفحه جزئیات کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.48",
    date: "Aug 20, 2024",
    changes: ["اصلاح فهرست تراکنش‌های کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.47",
    date: "Aug 19, 2024",
    changes: ["اصلاح تنظیمات و جزئیات کسب‌وکار", "تکمیل بارگذاری تصاویر درخواست‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.46",
    date: "Aug 18, 2024",
    changes: ["بهبود فهرست تراکنش‌های کاربر و تنظیمات تسویه", "اصلاح انتخاب و بارگذاری فایل در درخواست‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.44",
    date: "Aug 16, 2024",
    changes: ["بهبود صفحه جزئیات کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.43",
    date: "Aug 13, 2024",
    changes: ["تکمیل تنظیمات تسویه در جزئیات کسب‌وکار", "بازسازی فهرست تراکنش‌های کاربر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.42",
    date: "Aug 12, 2024",
    changes: ["بازسازی فهرست تراکنش‌ها و صفحه جزئیات کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.41",
    date: "Aug 11, 2024",
    changes: ["تکمیل فهرست درگاه‌ها و کسب‌وکارها", "اصلاح فرم درگاه و فهرست تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.40",
    date: "Aug 9, 2024",
    changes: ["بهبود صفحه جزئیات کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.39",
    date: "Aug 7, 2024",
    changes: ["اصلاح ورود و ارتباط با API احراز هویت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.38",
    date: "Aug 6, 2024",
    changes: ["بازسازی فرم درگاه و رفع خطاهای جزئیات کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.37",
    date: "Aug 5, 2024",
    changes: ["اصلاح ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.36",
    date: "Aug 4, 2024",
    changes: ["بهبود ورود خودکار، فهرست و فرم کسب‌وکار", "اصلاح تصاویر قانونی سایدبار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.35",
    date: "Aug 3, 2024",
    changes: [
      "بهبود احراز هویت، حساب‌ها و سایدبار کسب‌وکار",
      "افزودن چک‌باکس به فهرست تراکنش‌های کسب‌وکار و اصلاح فرم درگاه",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.34",
    date: "Aug 2, 2024",
    changes: ["اصلاح ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.33",
    date: "Jul 31, 2024",
    changes: ["تکمیل فرم‌ها، درگاه‌ها و تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.32",
    date: "Jul 30, 2024",
    changes: ["بازسازی سایدبار، کسب‌وکار و فرم‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.31",
    date: "Jul 29, 2024",
    changes: ["اصلاح فرم کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.30",
    date: "Jul 28, 2024",
    changes: ["بازسازی فرم کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.29",
    date: "Jul 27, 2024",
    changes: ["افزودن مدیریت وضعیت احراز هویت", "بهبود بارگذاری فایل و تصاویر"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.28",
    date: "Jul 23, 2024",
    changes: ["رفع خطاهای حساب‌ها و سرویس‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.27",
    date: "Jul 22, 2024",
    changes: ["بهبود بارگذاری پروفایل در داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.26",
    date: "Jul 10, 2024",
    changes: ["بهبود مؤلفه‌های فرم"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.25",
    date: "Jul 9, 2024",
    changes: ["رفع خطاهای فرم درگاه و افزودن فهرست کشورها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.24",
    date: "Jul 8, 2024",
    changes: ["رفع خطاهای صفحه درخواست‌ها و فرم‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.23",
    date: "Jul 7, 2024",
    changes: ["افزودن صفحه‌بندی فهرست کسب‌وکار", "اصلاح فرم درگاه و دکمه ایمیل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.22",
    date: "Jul 6, 2024",
    changes: ["بازسازی صفحه ورود اولیه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.21",
    date: "Jul 3, 2024",
    changes: ["بازسازی فهرست انتخاب کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.20",
    date: "Jul 2, 2024",
    changes: ["بازسازی فرم احراز هویت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.19",
    date: "Jun 30, 2024",
    changes: ["افزودن نخستین آزمون پروژه و اصلاح مسیر افزودن حساب"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.18",
    date: "Jun 24, 2024",
    changes: ["رفع خطاهای ورود کاربر و فهرست کسب‌وکارها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.17",
    date: "Jun 23, 2024",
    changes: ["افزودن جزئیات داشبورد و اصلاح نمایش کسب‌وکار در سایدبار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.16",
    date: "Jun 22, 2024",
    changes: [
      "رفع خطاهای نمایش و پیمایش در داشبورد، سایدبار، حساب‌ها، کسب‌وکارها و درخواست‌ها",
      "بهبود اعتبارسنجی کاربر و نمایش صفحه‌های خطا",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.15",
    date: "Jun 19, 2024",
    changes: ["پاک کردن خطاهای مشاهده‌شده در کنسول پروژه", "برطرف کردن باگ منوی سایدبار پنل کاربری"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.14",
    date: "Jun 18, 2024",
    changes: ["تنظیم کوکی‌های ورود و پاک‌سازی خطاهای مربوط به آن"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.13",
    date: "May 19, 2024",
    changes: ["حذف جست‌وجو از سربرگ", "افزودن واریز به حساب بانکی", "افزودن پیام تغییر حساب در کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.12",
    date: "May 15, 2024",
    changes: [
      "بهبود اندازه نوشته‌ها، صفحه‌بندی و نوارهای کناری",
      "افزودن صفحه‌بندی به حساب‌ها و درخواست‌ها",
      "اصلاح نمایش کارمزد و شماره شبا",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.10",
    date: "May 6, 2024",
    changes: ["اصلاح توضیحات صفحات"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.9",
    date: "Apr 28, 2024",
    changes: ["اصلاح نمایش زمان انقضای پرداخت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.8",
    date: "Mar 17, 2024",
    changes: ["افزودن QR کد به فرم‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.7",
    date: "Mar 16, 2024",
    changes: ["نمایش نام فایل‌ها هنگام بارگذاری"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.6",
    date: "Mar 9, 2024",
    changes: [
      "یکپارچه‌سازی مدیریت خطا در حساب‌ها، تسویه، فرم‌ها، درخواست‌ها و تراکنش‌ها",
      "افزودن خروجی اکسل تراکنش‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.5",
    date: "Mar 5, 2024",
    changes: [
      "افزودن دکمه رد درخواست",
      "بهبود تاریخ انقضا و مبلغ هدف در فرم پرداخت",
      "افزودن رسید تراکنش و خروجی اکسل",
      "افزودن پیش‌نمایش تصویر در گفت‌وگوی درخواست‌ها",
      "بهبود فهرست‌های انتخابی و تصویر پروفایل",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.4",
    date: "Mar 3, 2024",
    changes: [
      "افزودن صفحه و فهرست تسویه‌ها",
      "بهبود فرم و ردیف‌های درخواست‌ها",
      "اتصال تنظیمات کسب‌وکار به صفحه جزئیات",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.3",
    date: "Mar 1, 2024",
    changes: [
      "افزودن فعال‌سازی و غیرفعال‌سازی حساب و درگاه",
      "اصلاح زمان انقضا و نمایش اطلاعات تراکنش",
      "بهبود اعتبارسنجی فرم‌ها و پیام‌های صفحه ورود",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.2",
    date: "Feb 29, 2024",
    changes: [
      "افزودن QR کد به فرم‌ها",
      "افزودن فیلتر اعلان‌ها",
      "اصلاح نمایش تصویر پروفایل و اعداد",
      "بهبود اطلاعات پرداخت‌کننده و وضعیت اجباری فرم‌ها",
      "بهبود کارت درگاه",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.1",
    date: "Feb 28, 2024",
    changes: [
      "افزودن صفحه تنظیمات اعلان‌ها",
      "افزودن فعال‌سازی و غیرفعال‌سازی حساب‌ها",
      "بهبود فهرست کسب‌وکارها و درخواست‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.8.0",
    date: "Feb 21, 2024",
    changes: ["بهبود نمایش حساب‌ها و فرم‌ها، وضعیت شمارنده و تاریخ", "افزودن تنظیمات نمایش درگاه و فرم"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.7",
    date: "Feb 20, 2024",
    changes: ["افزودن فهرست درخواست‌های درگاه", "اصلاح نتیجه تراکنش"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.6",
    date: "Feb 19, 2024",
    changes: [
      "افزودن فهرست حساب‌های فعال برای درخواست‌ها",
      "افزودن فهرست فرم‌ها و درخواست‌ها",
      "بهبود اعلان‌ها و گزینه‌های فرم",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.5",
    date: "Feb 17, 2024",
    changes: ["افزودن اعلان‌ها به داشبورد و سربرگ", "بهبود صفحه‌بندی و مسیر تراکنش‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.4",
    date: "Feb 13, 2024",
    changes: [
      "افزودن امکان بارگذاری تصویر در گفت‌وگوی درخواست",
      "بهبود حالت بارگذاری دکمه‌ها و ارتباط تراکنش‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.2",
    date: "Feb 10, 2024",
    changes: ["افزودن پیوست به درخواست‌ها و امکان بارگذاری فایل", "تنظیم نشانی‌های API با متغیرهای محیطی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.1",
    date: "Feb 9, 2024",
    changes: [
      "افزودن فرم داشبورد برای فرم‌ها و درگاه‌ها",
      "افزودن بارگذاری تصاویر و نمایش تصویر پروفایل",
      "افزودن صفحه‌بندی و شناسه به فهرست‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.7.0",
    date: "Feb 8, 2024",
    changes: [
      "افزودن مسیرهای پرداخت، تراکنش و گفت‌وگوی درخواست‌ها",
      "افزودن صفحه جزئیات کسب‌وکار و فرم داشبورد",
      "افزودن وضعیت فعال و غیرفعال حساب",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.6.1",
    date: "Feb 3, 2024",
    changes: [
      "افزودن بخش درخواست‌ها، فهرست درخواست و ثبت درخواست جدید",
      "افزودن مدیریت خطا برای فرم‌ها و فهرست‌ها",
      "افزودن حالت بارگذاری دکمه‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.6.0",
    date: "Jan 31, 2024",
    changes: [
      "افزودن فهرست درخواست‌ها و ثبت درخواست جدید",
      "افزودن اطلاعات کاربر و تأیید ایمیل",
      "بهبود فرم پرداخت و ورودی شبا",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.14",
    date: "Jan 28, 2024",
    changes: ["افزودن اولویت و دسته‌بندی درخواست", "افزودن ثبت درخواست جدید"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.13",
    date: "Jan 27, 2024",
    changes: ["افزودن فرم پرداخت برای خریدار و API خرید", "بهبود جابه‌جایی بین پنل کاربر و کسب‌وکار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.12",
    date: "Jan 26, 2024",
    changes: [
      "بهبود منوهای کسب‌وکار و حساب‌ها",
      "قابل اسکرول شدن زیرمنوها",
      "بهبود تب‌های فرم و قالب‌بندی ورودی عدد",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.11",
    date: "Jan 25, 2024",
    changes: ["بهبود ورود و تأیید OTP و پیام خطا", "اصلاح فرم ایمیل و انتخاب‌گر تاریخ"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.10",
    date: "Jan 24, 2024",
    changes: ["افزودن فرم مالی برای خریدار", "اصلاح مبلغ و مبلغ هدف در فرم"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.9",
    date: "Jan 23, 2024",
    changes: [
      "بهبود وضعیت ثبت کسب‌وکار و تأیید درخواست",
      "افزودن فیلدهای تکمیلی کسب‌وکار",
      "اصلاح نوار پیمایش داشبورد",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.8",
    date: "Jan 22, 2024",
    changes: [
      "واکنش‌گرا شدن داشبورد، سربرگ و پابرگ",
      "افزودن فرم مالی و اتصال آن",
      "بهبود فرم‌های کسب‌وکار و مدیریت پین درگاه",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.7",
    date: "Jan 17, 2024",
    changes: [
      "افزودن فرم کسب‌وکار حقیقی و حقوقی",
      "بهبود فهرست‌های انتخابی و مسیر درگاه",
      "افزودن شناسه کسب‌وکار به ثبت درگاه",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.6",
    date: "Jan 14, 2024",
    changes: [
      "افزودن صفحات و فرم‌های درگاه",
      "افزودن اعتبارسنجی فرم درگاه",
      "پشتیبانی از اعداد فارسی و انواع کسب‌وکار",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.5",
    date: "Jan 13, 2024",
    changes: ["بهبود فهرست کسب‌وکار و حساب‌ها", "افزودن فعال‌سازی و غیرفعال‌سازی و جابه‌جایی درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.4",
    date: "Jan 11, 2024",
    changes: [
      "بهبود ورود کاربر جدید و نمایش وضعیت آن",
      "بهبود منوها و زیرمنوها",
      "اصلاح اطلاعات کاربر و فرم ورود اولیه",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.3",
    date: "Jan 10, 2024",
    changes: ["انتقال مدیریت منو به ساختار جدید", "اصلاح ورودی OTP و مقادیر فرم ثبت‌نام"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.2",
    date: "Jan 9, 2024",
    changes: [
      "افزودن جزئیات کسب‌وکار و مدیریت وضعیت آن",
      "انتقال منوها و سایدبار به ساختار جدید",
      "بهبود فرم و بارگذاری تصاویر",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.1",
    date: "Jan 4, 2024",
    changes: ["افزودن ارتباط با API برای حساب بانکی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.5.0",
    date: "Jan 2, 2024",
    changes: [
      "افزودن مدیریت وضعیت سامانه",
      "افزودن بارگذاری تصاویر و پشتیبانی از کشیدن و رها کردن",
      "بهبود فرم ثبت‌نام و منوی کاربر",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.12",
    date: "Jan 1, 2024",
    changes: ["افزودن صفحه تنظیمات و امنیت", "افزودن مدیریت فعال‌سازی و غیرفعال‌سازی درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.10",
    date: "Dec 30, 2023",
    changes: ["افزودن اعتبارسنجی فیلترهای ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.9",
    date: "Dec 29, 2023",
    changes: ["بهبود شرط‌های ورودی فرم درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.8",
    date: "Dec 28, 2023",
    changes: ["افزودن صفحه اصلی درگاه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.7",
    date: "Dec 27, 2023",
    changes: [
      "افزودن تأیید ایمیل",
      "افزودن فهرست کشور با جست‌وجو",
      "بهبود اعتبارسنجی شماره شبا و درگاه و زمان‌سنج OTP",
      "افزودن صفحه حساب‌ها",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.6",
    date: "Dec 24, 2023",
    changes: ["بهبود راهنماهای فرم و افزودن تصویر خطا"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.5",
    date: "Dec 20, 2023",
    changes: ["افزودن حالت بارگذاری و آیکون هشتگ", "افزودن تبدیل تاریخ جلالی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.4",
    date: "Dec 19, 2023",
    changes: ["تکمیل صفحه تراکنش‌ها و ارتباط با API", "بهبود بارگذاری حساب بانکی و ثبت‌نام"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.3",
    date: "Dec 17, 2023",
    changes: [
      "افزودن استعلام شبا و تبدیل شبا به کارت",
      "بهبود پیام خطا و بارگذاری افزودن حساب",
      "نمایش وضعیت افزودن حساب",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.2",
    date: "Dec 13, 2023",
    changes: ["افزودن زمان‌سنج OTP و استعلام شبا", "افزودن انتخاب‌گر تاریخ تولد", "اصلاح تخفیف فرم مالی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.1",
    date: "Dec 12, 2023",
    changes: [
      "بهبود مدیریت OTP و فهرست کاربر",
      "افزودن انتخاب‌گر تاریخ و فهرست‌های کشویی",
      "افزودن ارتباط با API حساب بانکی",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.4.0",
    date: "Dec 6, 2023",
    changes: [
      "افزودن فرم ثبت کسب‌وکار و ارتباط با API",
      "افزودن فرم مالی",
      "بهبود پیمایش فرم‌ها و خروج از حساب",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.8",
    date: "Dec 2, 2023",
    changes: ["بهبود واکنش‌گرایی داشبورد", "افزودن استعلام کارت"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.7",
    date: "Nov 27, 2023",
    changes: ["افزودن گزینه‌های ویرایش فرم و کنترل ورودی عدد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.5",
    date: "Nov 25, 2023",
    changes: ["افزودن فرم مالی و ارتباط با API", "بهبود ورود و OTP", "افزودن کنترل ورودی عدد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.4",
    date: "Nov 22, 2023",
    changes: [
      "افزودن مؤلفه ورودی عددی و گزینه‌های روشن و خاموش",
      "بهبود بارگذاری فایل",
      "بهبود انتقال پس از تأیید ورود",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.3",
    date: "Nov 19, 2023",
    changes: ["افزودن انتخاب‌گر تاریخ و ارتباط API برای شبا و کسب‌وکار", "بهبود OTP و فهرست حساب"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.2",
    date: "Nov 11, 2023",
    changes: ["افزودن بارگذاری فایل و تصویر در ثبت‌نام", "افزودن مسیر محافظت‌شده داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.1",
    date: "Nov 5, 2023",
    changes: ["افزودن تأیید ایمیل"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.3.0",
    date: "Nov 4, 2023",
    changes: [
      "تکمیل فرم مالی کسب‌وکار",
      "افزودن بارگذاری تصویر و کلیدهای روشن و خاموش",
      "بهبود مسیرهای ورود",
    ],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.8",
    date: "Oct 23, 2023",
    changes: ["بهبود فرم درگاه و مدیریت وضعیت‌ها"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.7",
    date: "Oct 22, 2023",
    changes: ["افزودن فرم جدید کسب‌وکار", "بهبود وضعیت و مسیرهای داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.6",
    date: "Oct 21, 2023",
    changes: ["افزودن فرم درگاه و وضعیت کسب‌وکار و ورود"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.4",
    date: "Oct 19, 2023",
    changes: ["افزودن نمایش وضعیت اطلاعات کاربر و ثبت‌نام خارجی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.3",
    date: "Oct 18, 2023",
    changes: ["افزودن بخش حساب‌های بانکی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.2",
    date: "Oct 15, 2023",
    changes: ["افزودن فرم کسب‌وکار جدید"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.1",
    date: "Oct 14, 2023",
    changes: ["افزودن فرم و بارگذاری برای ثبت‌نام اولیه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.2.0",
    date: "Oct 13, 2023",
    changes: ["افزودن مسیر و صفحه داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.9",
    date: "Oct 10, 2023",
    changes: ["افزودن سایدبار، منو و زیرمنو", "افزودن پابرگ"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.8",
    date: "Oct 9, 2023",
    changes: ["افزودن سایدبار"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.7",
    date: "Oct 8, 2023",
    changes: ["افزودن بخش حساب بانکی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.6",
    date: "Oct 7, 2023",
    changes: ["افزودن راهنما و صفحه یافت نشد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.5",
    date: "Oct 4, 2023",
    changes: ["اصلاح سربرگ داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.4",
    date: "Oct 3, 2023",
    changes: ["افزودن داشبورد و بخش‌های آن", "بهبود نمایش تصویر راهنما"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.3",
    date: "Oct 2, 2023",
    changes: ["افزودن مؤلفه‌های ورودی"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.2",
    date: "Oct 1, 2023",
    changes: ["افزودن مؤلفه اطلاعات تماس"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.1",
    date: "Sep 30, 2023",
    changes: ["افزودن نوار پیمایش دوم به داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.1.0",
    date: "Sep 29, 2023",
    changes: ["افزودن داشبورد"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.0.3",
    date: "Sep 26, 2023",
    changes: ["افزودن مؤلفه دکمه با اندازه واکنش‌گرا"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.0.2",
    date: "Sep 25, 2023",
    changes: ["بهبود پیام خطا و افزودن مؤلفه دکمه"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.0.1",
    date: "Sep 24, 2023",
    changes: ["افزودن اعتبارسنجی ثبت‌نام اولیه و OTP", "بهبود برچسب‌های خطا"],
  },
  {
    title: "VandaPardakht (user panel)",
    version: "1.0.0",
    date: "Sep 23, 2023",
    changes: [
      "راه‌اندازی پروژه",
      "افزودن ظاهر پایه و فونت",
      "افزودن ثبت‌نام اولیه و ورود با OTP",
      "تنظیم نماد مرورگر",
    ],
  },
];
